<template>
  <div :class="{ 'bg-saved': value.saved }">
    <span class="icon-offer-wrapper">
      <md-icon class="offer" v-if="value.offer_status == 'OFFER'">
        sell
        <md-tooltip md-direction="top">
          Offer
          <ul>
            <li v-for="offer in value.offers" :key="offer">{{ offer }}</li>
          </ul>
        </md-tooltip>
      </md-icon>
      <md-icon class="offer md-icon-outlined" v-if="value.offer_status == 'PARTIAL_OFFER'">
        sell
        <md-tooltip md-direction="top">
          Partial offer
          <ul>
            <li v-for="offer in value.offers" :key="offer">{{ offer }}</li>
          </ul>
        </md-tooltip>
      </md-icon>
    </span>
    <div class="md-layout md-alignment-top-space-between" style="width: 100%;">
      <md-checkbox class="m-0" :model="value.is_selected" @change="toggleCheckbox" :disabled="!value.price_editable"></md-checkbox>
      <span style="font-weight: bold;  font-size: 14px;" v-if="value.current !== null && value.current !== undefined">
        {{ getPriceWithDecimals(value.current) }} {{ this.currency }}
      </span>
    </div>
    <ValidationProvider :rules="'positive'" v-slot="{ passed, failed }">
      <md-field
        :class="{
          'no-padding-bottom': true,
          'md-error': failed,
          'md-valid': passed,
          'margin-offer': true,
        }"
      >
        <!--
          si value_format es RELATIVE o PERCENTAGE, si el precio es positivo se pinte de verde
          Si es ABSOLUTE entonces se pintará de verde si amount es mayor que current y en rojo si amount es menor que currentt
        -->
        <md-input
          v-model.number="value.amount"
          :placeholder="originalValue ? String(originalValue) : ''"
          :class="{
            'text-align-right': true,
            'has-error':
              (valueFormat == 'ABSOLUTE' && parseFloat(actualValue) < parseFloat(value.current)) ||
              (valueFormat != 'ABSOLUTE' && parseFloat(actualValue) < 0),
            'has-success':
              (valueFormat == 'ABSOLUTE' && parseFloat(actualValue) > parseFloat(value.current)) ||
              (valueFormat != 'ABSOLUTE' && parseFloat(actualValue) > 0),
          }"
          size="4"
          @input="onChange"
          :disabled="!value.price_editable"
          @keypress="isNumber($event)"
          tabindex="1"
        ></md-input>
        <span class="symbol">{{ symbol }}</span>
        <slide-y-down-transition>
          <md-icon class="error" v-show="failed">close</md-icon>
        </slide-y-down-transition>
      </md-field>
    </ValidationProvider>
  </div>
</template>
<script>
/*eslint-disable */

import { extend } from 'vee-validate'
import { required_if } from 'vee-validate/dist/rules'
import { Fragment } from 'vue-fragment'
import { SlideYDownTransition } from 'vue2-transitions'
import Currency from '@/utils/Currency'

extend('positive', (value) => {
  return true
})
extend('required_if', required_if)

let currency

export default {
  name: 'PricingTableEditableElement',
  components: { Fragment, SlideYDownTransition },
  props: {
    value: Object,
    symbol: String,
    valueFormat: String,
    roomTypeId: String,
    recommendedValue: Number,
  },
  data() {
    return {
      randomVid: Math.floor(Math.random() * 1000000),
    }
  },
  computed: {
    hasChanged() {
      return this.actualValue !== '' && this.originalValue != this.actualValue
    },
    actualValue() {
      return this.value.amount
    },
    originalValue() {
      return this.value.originalAmount
    },
  },
  methods: {
    onChange() {
      this.value.edited_by_user = this.hasChanged

      if (this.hasChanged) this.toggleCheckbox(true)
    },
    toggleCheckbox(value) {
      this.$set(this.value, 'is_selected', value)
      this.$emit('change', value)
    },
    isNumber: function(evt) {
      let keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-']
      let keyPressed = evt.key

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    getPriceWithDecimals(value) {
      let showDecimals = sessionStorage.getItem('show-decimals')
      if (showDecimals === 'false') {
        let aux = value
        if (typeof value === 'number') {
          aux = value.toString()
        }
        return aux.split('.')[0]
      } else {
        return value
      }
    },
  },
  created() {
    this.currency = Currency[sessionStorage.getItem('currency')]
  },
}
</script>
<style lang="scss">
.pricing-cell {
  border: none !important;
  min-width: 103px !important;
  max-width: 103px !important;
}

.symbol {
  margin-left: 0.25em;
  display: flex;
  align-items: center;
}
.text-align-right {
  text-align: right;
}
.no-padding-bottom {
  padding-bottom: 0px;
}
.offer {
  position: absolute;
  top: 40px;
  opacity: 0.75;
  font-size: 1.25em !important;
}
.margin-offer {
  margin: 0 0 0 0;
}
.icon-offer-wrapper i {
  z-index: 1;
}
</style>
